/**
 * Created by Ivan on 02.09.2025
 */

cleverapps.override(cleverapps.EVENTS, {
    SCORE_BAR_COMPLETE_STAGE: "score_bar_stage",
    SCORE_BAR_ACCEPT_REWARD: "score_bar_accept"
});
